var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { WINDOW_KEY } from "../../constants";
const useGetExternalRecordingInfo = () => {
  var _a;
  const recordingIdFromWindow = (_a = window == null ? void 0 : window.__GlobalSessionReplayRecordingContext) == null ? void 0 : _a.id;
  if (!recordingIdFromWindow) {
    return {
      recordingId: "",
      isRecording: false
    };
  } else {
    return {
      recordingId: recordingIdFromWindow,
      isRecording: true
    };
  }
};
const saveExternalBlackBoxRecording = (experimentId) => __async(void 0, null, function* () {
  var _a;
  try {
    if (!(window == null ? void 0 : window[WINDOW_KEY.SAVE_BLACKBOX_RECORDING])) {
      console.error("Session Replay - Blackbox recording not initialized yet");
      return void 0;
    }
    const recordingId = yield (_a = window == null ? void 0 : window[WINDOW_KEY.SAVE_BLACKBOX_RECORDING]) == null ? void 0 : _a.call(window, experimentId);
    return recordingId;
  } catch (e) {
    console.error(e, "Session Replay - Error saving blackbox recording");
  }
});
export {
  saveExternalBlackBoxRecording,
  useGetExternalRecordingInfo
};
